export const OPEN_CONTENIDO = 'OPEN_CONTENIDO';
export const CLOSE_CONTENIDO = 'CLOSE_CONTENIDO';

export const accionOpenContenido = (bundle) => ({
    type: OPEN_CONTENIDO,
    bundle: bundle
});
export const accionCloseContenido = () => ({
  type: CLOSE_CONTENIDO
});